module.exports = __webpack_public_path__ + "media/images/other-images/calender-bg-6af4cca4caddbadd05840601dd361cd4.png";